// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SocialYouTube: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fillRule="evenodd" d="M22.1 29.8V19.1l8.3 5.3-8.3 5.4zm17.4-10.5c0-2.3-1.9-4.2-4.3-4.2H14.8c-2.4 0-4.3 1.9-4.3 4.2v11.3c0 2.3 1.9 4.2 4.3 4.2h20.4c2.4 0 4.3-1.9 4.3-4.2V19.3z" clipRule="evenodd"/></svg>;
};

export default React.memo(SocialYouTube);
